module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_kit-checkout-e0a107f2469ca0a69fea38a534988944.jpg";